/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import { Checkbox } from './ui/checkbox';

import SendMutation from '../mutations/SendMutation';

import APIHOST from '../const';
import $ from 'jquery';
import { createRequestError } from '../RelayEnv';
import defaultMessage from '../defaultMessage';
import Store from './Store';

class SimpleCurl extends React.Component {
  constructor(props) {
    super(props);
    this.onEdit = this.onEdit.bind(this);
    this.onSend = this.onSend.bind(this);
    this.copy = this.copy.bind(this);
    this.onSync = this.onSync.bind(this);
    this.state = {
      response: null,
      message: defaultMessage(),
      copied: false,
      sync: false,
      edit: false,
      activeTab: 0,
    };
  }

  onEdit(e) {
    return this.setState({
      edit: !this.state.edit,
    });
  }

  async onSend(e) {
    e.preventDefault();

    if (this.current != null) {
      this.current.abort();
    }

    if (this.props.onSuccess == null) {
      this.setState({
        response: null,
      });
    }
    if (this.props.onSend != null) {
      this.props.onSend();
    }

    const headers = {};

    headers['Authorization'] = 'Bearer ' + this.props.accessToken;

    const msg = {
      id: this.props.id,
      title: this.state.message.title,
      body: this.state.message.body,
      action1: this.state.message.action0.enabled
        ? this.state.message.action0.text
        : null,
      action2: this.state.message.action1.enabled
        ? this.state.message.action1.text
        : null,
      reply: this.state.message.action2.enabled
        ? this.state.message.action2.text
        : null,
    };

    if (!this.props.onResponse) {
      return SendMutation.commit(this.props.id, msg, this.onSuccess);
    } else {
      return (this.current = $.ajax({
        url: `${APIHOST}/v1/send_sync`,
        headers,
        type: 'POST',
        data: msg,
        success: resp => {
          if (this.props.onResponse != null) {
            this.props.onResponse(resp);
            return;
          }
          return this.setState({
            response: resp,
          });
        },
        error: (res, status, error) => {
          let err;
          try {
            const json = JSON.parse(res.responseText);
            err = createRequestError(status, json);
            err = err.message;
          } catch (e) {
            err = res.responseText || error;
          }

          if (this.props.onResponse != null) {
            this.props.onResponse(null, err);
          } else {
            Store.onFailure(err);
          }
          return this.setState({
            responseLoading: false,
          });
        },
      }));
    }
  }

  copy(e) {
    let range;
    e.preventDefault();
    let text = `curl ${APIHOST}/v1/${this.state.sync ? 'send_sync' : 'send'}
-u ${this.props.accessToken}:
-d 'id=${this.props.id}'
-d 'title=${this.state.message.title}'
-d 'body=${this.state.message.body}'`;
    if (this.state.message.action0.enabled) {
      text += ` -d 'action1=${this.state.message.action0.text}'`;
    }
    if (this.state.message.action1.enabled) {
      text += ` -d 'action2=${this.state.message.action1.text}'`;
    }
    if (this.state.message.action2.enabled) {
      text += ` -d 'reply=${this.state.message.action2.text}'`;
    }
    const element = document.createElement('a');
    element.setAttribute('href', text);
    element.textContent = text;
    document.body.appendChild(element);
    if (document.selection) {
      range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
    } else if (window.getSelection) {
      range = document.createRange();
      range.selectNode(element);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }

    document.execCommand('copy');
    element.remove();
    return this.setState({
      copied: true,
    });
  }

  onSync(e) {
    return this.setState({
      sync: e.target.checked,
    });
  }

  handleChange(name) {
    return event => {
      return this.setState({ ...this.state, [name]: event.target.checked });
    };
  }

  actionChecked(action) {
    return checked => {
      const foo = Object.assign(this.state.message, {});
      foo[action]['enabled'] = checked;
      return this.setState({
        message: foo,
      });
    };
  }

  messageField(field) {
    return e => {
      const foo = Object.assign(this.state.message, {});
      foo[field] = e.target.value;
      return this.setState({
        message: foo,
      });
    };
  }

  actionField(field) {
    return e => {
      const foo = Object.assign(this.state.message, {});
      foo[field].text = e.target.value;
      return this.setState({
        message: foo,
      });
    };
  }

  render() {
    const message = {
      actions: [
        {
          id: 1,
          value: 'Action 1',
        },
        {
          id: 2,
          value: 'Action 2',
        },
        {
          id: 3,
          value: 'Reply',
        },
      ],
    };
    const isMobile = window.innerWidth < 600;
    console.log('message', message, 'state', this.state);
    return (
      <>
        <div className="grid grid-cols-12 gap-4">
          {this.state.edit || !isMobile ? (
            <div className="col-span-12 md:col-span-5">
              <div className="space-y-4">
                <div>
                  <Label htmlFor="title">Title</Label>
                  <Input
                    id="title"
                    className="mr-2.5"
                    onChange={this.messageField('title')}
                    type="text"
                    value={this.state.message.title}
                    required
                  />
                </div>
                <div>
                  <Label htmlFor="body">Body</Label>
                  <Input
                    id="body"
                    onChange={this.messageField('body')}
                    value={this.state.message.body}
                    type="text"
                  />
                </div>
                {message.actions.map((action, index) => {
                  const actionNum = 'action' + index;
                  return (
                    <div
                      key={action.id}
                      className="flex flex-row items-center gap-2"
                    >
                      <Input
                        onChange={this.actionField(actionNum)}
                        placeholder={action.value}
                        value={this.state.message[actionNum].text}
                        className="flex-1"
                      />
                      <Checkbox
                        onCheckedChange={this.actionChecked(actionNum)}
                        checked={this.state.message[actionNum].enabled}
                      />
                    </div>
                  );
                })}
                {!isMobile ? <Button onClick={this.onSend}>Send</Button> : null}
              </div>
            </div>
          ) : null}
          {isMobile ? (
            <div className="col-span-12 flex gap-2">
              <Button onClick={this.onEdit}>Edit</Button>
              <Button onClick={this.onSend}>Send</Button>
            </div>
          ) : null}
          <div className="col-span-12 md:col-span-7">
            {this.state.edit || !isMobile ? (
              <Tabs
                value={this.state.activeTab.toString()}
                onValueChange={value =>
                  this.setState({ activeTab: parseInt(value) })
                }
              >
                <TabsList>
                  <TabsTrigger value="0">Preview</TabsTrigger>
                  <TabsTrigger value="1">Code</TabsTrigger>
                </TabsList>
                <TabsContent value="0">
                  <div className="flex-1 p-1.5">
                    <p className="text-xs text-gray-400 mb-1.5">
                      Message preview
                    </p>
                    <p className="font-bold text-base mb-2">
                      {this.state.message.title}
                    </p>
                    <p className="mb-2">{this.state.message.body}</p>
                    <div className="flex flex-row flex-wrap gap-2">
                      {message.actions.map((action, index) => {
                        const actionNum = 'action' + index;
                        if (!this.state.message[actionNum].enabled) {
                          return null;
                        }
                        return (
                          <Button key={actionNum} variant="outline" size="sm">
                            {this.state.message[actionNum].text}
                          </Button>
                        );
                      })}
                    </div>
                  </div>
                </TabsContent>
                <TabsContent value="1">
                  <div className="mt-1">
                    {this.state.edit || !isMobile ? (
                      <>
                        <code>
                          <div className="method-example-request include-prompt">
                            <div className="language-bash break-words whitespace-pre-wrap text-[13px] font-normal before:content-['$_']">
                              curl {APIHOST}/v1/
                              {this.state.sync ? 'send_sync' : 'send'} \{'\n  '}
                              <span className="token api-key">
                                <span className="token request-flag">-u</span>{' '}
                                {this.props.accessToken}
                              </span>
                              : \{'\n  '}
                              <span className="token">
                                <span className="token request-flag">-d</span>{' '}
                                {`id=${this.props.id}`}
                              </span>{' '}
                              \{'\n  '}
                              <span className="token">
                                <span className="token request-flag">-d</span>{' '}
                                {`'title=${this.state.message.title}'`}
                              </span>{' '}
                              \{'\n  '}
                              <span className="token">
                                <span className="token request-flag">-d</span>{' '}
                                {`'body=${this.state.message.body}'`}
                              </span>
                              {this.state.message.action0.enabled ||
                              this.state.message.action1.enabled ||
                              this.state.message.action2.enabled ? (
                                <>&nbsp;\{'\n  '}</>
                              ) : null}
                              {this.state.message.action0.enabled ? (
                                <>
                                  <span className="token">
                                    <span className="token request-flag">
                                      -d
                                    </span>{' '}
                                    {`'action1=${this.state.message.action0.text}'`}
                                  </span>
                                  {this.state.message.action1.enabled ||
                                  this.state.message.action2.enabled ? (
                                    <>&nbsp;\{'\n  '}</>
                                  ) : null}
                                </>
                              ) : null}
                              {this.state.message.action1.enabled ? (
                                <>
                                  <span className="token">
                                    <span className="token request-flag">
                                      -d
                                    </span>{' '}
                                    {`'action2=${this.state.message.action1.text}'`}
                                  </span>
                                  {this.state.message.action2.enabled ? (
                                    <>&nbsp;\{'\n  '}</>
                                  ) : null}
                                </>
                              ) : null}
                              {this.state.message.action2.enabled ? (
                                <>
                                  <span className="token">
                                    <span className="token request-flag">
                                      -d
                                    </span>{' '}
                                    {`'reply=${this.state.message.action2.text}'`}
                                  </span>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </code>
                      </>
                    ) : null}
                    {this.state.edit || !isMobile ? (
                      <>
                        <Button onClick={this.copy} className="mt-2">
                          {this.state.copied ? 'Copied' : 'Copy'}
                        </Button>
                        <div className="flex items-center gap-2 mt-2 ml-2.5">
                          <Checkbox
                            onCheckedChange={checked =>
                              this.setState({ sync: checked })
                            }
                            checked={this.state.sync}
                            id="sync-mode"
                          />
                          <Label htmlFor="sync-mode">Synchronous mode</Label>
                        </div>
                        {this.state.sync ? (
                          <div className="mt-2">
                            Caution: A synchronous connection can be terminated
                            at anytime.{' '}
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              href="https://pushback.io/docs/sync/"
                              className="text-primary underline"
                            >
                              Learn more
                            </a>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                    <div className="mt-4">
                      Visit{' '}
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://pushback.io/docs/getting-started/"
                        className="text-primary underline"
                      >
                        Getting Started
                      </a>{' '}
                      for other language examples
                    </div>
                  </div>
                </TabsContent>
              </Tabs>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default SimpleCurl;
